import { Box, Button, CircularProgress, ITheme, Typography, useTheme } from '@mui/material'
import React, { useState } from 'react'
import BackButton from '../../common/BackButton'
import { useTranslation } from 'react-i18next'
import PortfolioDocumentationStepItem from './PortfolioDocumentationStepItem'
import { useAppDispatch, useAppSelector } from '../../../store/reducers/store'
import { incorporatePortfolio, submitPortfolio } from '../../../store/actions/createPortfolio'
import { useNavigate, useParams } from 'react-router-dom'
import { AUTHENTICATED_ROUTES } from '../../../resources/routes-constants'
import { PortfolioIncorporation } from '../../../models/Portfolio'

const PortfolioDocumentationStep: React.FC = () => {
    const { t } = useTranslation();
    const portfolio = useAppSelector(state => state.createPortfolio.portfolio);
    const theme = useTheme() as ITheme;
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { id } = useParams();

    const onIncorporateWithLeo = () => {
        setIsSubmitting(true);
        dispatch(incorporatePortfolio(PortfolioIncorporation.Leo)).then(() => {
            dispatch(submitPortfolio()).then(() => {
                navigate(AUTHENTICATED_ROUTES.PORTFOLIO_SUBMITTED_ROUTE.replace(":id", `${portfolio.id}`))
            });
        });
    }
    const onIncorporateUsingYourOwnLawyer = () => {
        setIsSubmitting(true);
        dispatch(incorporatePortfolio(PortfolioIncorporation.Customer)).then(() => {
            navigate((id !== undefined ? AUTHENTICATED_ROUTES.PORTFOLIO_EDIT_STEP_ROUTE.replace(":id", id) : AUTHENTICATED_ROUTES.PORTFOLIO_CREATE_STEP_ROUTE).replace(":step", '7'));
        });
    }

    const documents = [
        {name: "Fund Prospectus", description: "A document detailing a fund’s investment objectives, strategies, risks, performance, and management to inform potential investors."},
        {name: "Term Sheet", description: "A summary of the key terms and conditions of a proposed investment deal, outlining the investment amount, valuation, and investor rights."}
    ];
    return <Box display={"flex"} flexDirection={"column"} width={"1400px"} gap={"24px"} paddingBottom={"50px"}>
        <Box display={"flex"} alignItems={"center"} gap={"24px"}>
            <BackButton disabled={isSubmitting} />
            <Typography fontSize={"24px"} fontWeight={"500"} lineHeight={"29.26px"}>{t('CreatePortfolioViewYourDocuments')}</Typography>
        </Box>
        <Box display={"flex"} gap={"49px"}>
            {documents.map((d,i) => <PortfolioDocumentationStepItem title={d.name} description={d.description} url='' key={`document-${i}`} />)}
        </Box>
        <Box display={"flex"} width={"100%"} justifyContent={"flex-end"} gap={"16px"}>
            <Button variant='contained' disabled={isSubmitting} onClick={onIncorporateWithLeo}>
                {t('CreatePortfolioIncorporateWithLeo')}
                {isSubmitting && (<CircularProgress
                    size={24}
                    sx={{
                        color: theme.palette.primary.dark,
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-12px',
                        marginLeft: '-12px',
                    }}
                />)}
            </Button>
            <Button variant='outlined' disabled={isSubmitting} onClick={onIncorporateUsingYourOwnLawyer}>
                {t('CreatePortfolioIncorporateUsingYourOwnLawyer')}

                {isSubmitting && (<CircularProgress
                    size={24}
                    sx={{
                        color: theme.palette.primary.dark,
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-12px',
                        marginLeft: '-12px',
                    }}
                />)}
            </Button>
        </Box>
    </Box>
}

export default PortfolioDocumentationStep